import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { getInstanceRegion, isLargeScreen } from '../../../../global.variable';
import { AppService } from '../../../app.service';

import { DeviceInfoService } from '../../services/device-info.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { Validators } from '@angular/forms';
import { UserProfileService } from '../../../profile/user-profile/user-profile.service';

@Component({
  selector: 'gtapp-address-lookup',
  templateUrl: './address-lookup.component.html',
  styleUrl: './address-lookup.component.scss',
  standalone: false,
})
export class AddressLookupComponent implements OnInit {
  @ViewChild('addressFormTemplate') addressFormTemplate!: ElementRef;
  @Input() addressForm: any;
  @Input() placeholder: string = 'Lookup Address';
  @Input() editSelectedAddress: boolean = false;
  @Input() showLookupFrom: string = 'addAddress';
  addressMapId = `smallMapId${uuidv4()}`;

  @Input() reverseLookupGps: any;

  @Output() updateAddress = new EventEmitter();
  @Output() lookupNewAddress = new EventEmitter();

  invalidFields: any = [];
  addrLookupData: any = [];

  addressValue: string = '';
  largeView: Boolean = isLargeScreen;
  instanceRegion = getInstanceRegion();

  thirdPartyLookupTimeoutFn: any;

  showMap: boolean = false;

  // googleAutoCompleteSearch: any;
  constructor(
    private profileService: UserProfileService,
    private appService: AppService,
    private spinnerService: LoadingSpinnerService,
    private deviceInfoService: DeviceInfoService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // this.googleAutoCompleteSearch =
    //   new google.maps.places.AutocompleteSuggestion();
    this.updateFullAddress(this.addressForm.value);
  }
  onFormBlur(event: FocusEvent) {
    if (!this.addressFormTemplate.nativeElement.contains(event.relatedTarget)) {
      setTimeout(() => {
        this.editSelectedAddress = this.addressFormInValidCheck();
        if (!this.editSelectedAddress) {
          this.showMap = false;
          this.updateAddress.emit(this.addressForm.value);
          this.updateFullAddress(this.addressForm.value);
          this.cdr.detectChanges();
        }
      }, 1);
    }
  }

  forceUppercaseConditionally(event: any, field: string = 'city_name') {
    this.addressForm.controls[field].setValue(event.target.value.toUpperCase());
  }

  onSearchAnotherAddress() {
    this.editSelectedAddress = false;
    this.showMap = false;
    this.lookupNewAddress.emit(true);
    const addressFields = [
      'address1',
      'address2',
      'address3',
      'city_name',
      'postcode',
      'state_code',
      'latitude',
      'longitude',
      'state_name',
    ];
    Object.keys(this.addressForm.controls).forEach((key) => {
      if (addressFields.includes(key)) {
        this.addressForm.get(key).reset();
      }
    });

    this.addressValue = '';

    this.shiftFocus();
  }
  shiftFocus() {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById('addressLookup');
      if (element) {
        element?.focus();
      }
    }, 100);
  }

  updateFullAddress(address: any) {
    if (!this.addressFormInValidCheck()) {
      const address3 = address?.address3 ? `${address?.address3},` : '';
      const address1 = address?.address1 || '';
      const address2 = address?.address2 || '';
      const city_name = address?.city_name || '';
      const state_code = address?.state_code || '';
      const state_name = address?.state_name || address?.state_code || '';
      const postcode = address?.postcode || '';
      const countryName =
        address?.country_name &&
        address?.country_name?.toLowerCase() !=
          this.instanceRegion?.toLowerCase()
          ? address?.country_name
          : '';
      this.addressValue =
        address?.full_address ||
        `${address3} ${address1} ${address2} ${city_name} ${
          state_name || state_code
        } ${postcode} ${countryName}`.trim();
    }
  }
  addressFormInValidCheck(): boolean {
    const fields = ['address2', 'city_name', 'state_code', 'state_name'];

    return fields.some((field) => {
      const control = this.addressForm.controls[field];
      return control.validator && control.invalid;
    });
  }
  addressSelected(address: any) {
    if (address?.key === 0) {
      this.useCurrentLocation();
    } else if (address && typeof address === 'object') {
      this.showMap = false;
      const selectedLat =
        address?.latitude || address?.properties?.coordinates?.latitude;
      const selectedLon =
        address?.longitude || address?.properties?.coordinates?.longitude;

      if (selectedLon && selectedLat) {
        let selectedAddress: any = {
          address1: address?.address1 || '',
          address2: address?.address2,
          address3: address?.address3,
          city_name: address?.city_name,
          postcode: address?.postcode,
          state_code: address?.state_code,
          state_name: address?.state_name || address?.state_code,
          country_name: address?.country_name,
          latitude: selectedLat,
          longitude: selectedLon,
        };

        if (address.hasOwnProperty('properties')) {
          let streetName =
            address?.properties?.context?.street?.name ||
            address?.properties?.address;
          let prefix: any = null;

          if (
            address?.properties?.name &&
            address?.properties?.feature_type !== 'address'
          ) {
            // this means its a poi rather than a proper address

            if (streetName) {
              prefix = address?.properties?.name;
            } else {
              streetName = address?.properties?.name;
            }
          }

          selectedAddress = this.dictStringConvert({
            address1:
              address?.properties?.context?.address?.address_number || '',
            address2: streetName,
            address3: prefix,
            city_name:
              address?.properties?.context?.neighborhood?.name ||
              address?.properties?.context?.locality?.name ||
              address?.properties?.context?.place?.name,
            state_code:
              address?.properties?.context?.region?.region_code ||
              address?.properties?.context?.region?.name,
            state_name:
              address?.properties?.context?.region?.name ||
              address?.properties?.context?.region?.region_code,
            longitude: selectedLon,
            latitude: selectedLat,
            postcode: address?.properties?.context?.postcode?.name,
            country_name: address?.properties?.context?.country?.name,
          });
        }

        this.editSelectedAddress = false;

        this.addressForm.patchValue(selectedAddress);

        if (this.addressFormInValidCheck()) {
          this.editSelectedAddress = true;
        }
        this.updateAddress.emit(this.addressForm.value);
        this.updateFullAddress(this.addressForm.value);
        this.cdr.detectChanges();
      } else if (address?.mapbox_id) {
        // item is from the mapbox suggest api so need to maek the retrive api call to get the full detauls which contains coordinates
        this.mapBoxRetrieveAddress(address?.mapbox_id);
      } else if (address?.placePrediction?.placeId) {
        // item is from the google auto complete api so need to maek the retrive api call to get the full detauls which contains coordinates
        this.googlePlacesRetrieveAddress(address?.placePrediction?.placeId);
      }
    }
  }

  gtAddressDbLookup(searchStr: any, params?: any) {
    if (this.appService.getToken()) {
      this.profileService
        .addressLookup(searchStr, params)
        .subscribe((res: any) => {
          this.addrLookupData = res?.data;
          this.cdr.detectChanges();
        });
    } else {
      this.appService
        .addressLookupShared(searchStr, params)
        .subscribe((res: any) => {
          this.addrLookupData = res?.data;
          this.cdr.detectChanges();
        });
    }
  }
  mapBoxRetrieveAddress(mapBoxId: any) {
    let params: any = {
      search_3rd_party: 1,
      address_method: 'retrieve',
      mapbox_id: mapBoxId,
    };
    this.spinnerService.show('Fetching coordinates');
    this.appService.addressLookupShared('', params).subscribe((res: any) => {
      this.spinnerService.hide();

      if (res?.data?.length) {
        this.addressSelected(res?.data[0]);
      }
    });
  }
  googlePlacesRetrieveAddress(placeId: any) {
    let params: any = {
      search_3rd_party: 1,
      address_method: 'retrieve',
      place_id: placeId,
    };
    this.spinnerService.show('Fetching coordinates');
    this.appService.addressLookupShared('', params).subscribe((res: any) => {
      this.spinnerService.hide();

      if (res?.data?.latitude) {
        this.addressSelected(res?.data);
      }
    });
  }

  onAddressSearch(addressSearch: any) {
    const googleSearchPrefixes = ['corner', 'crn'];
    const searchStr = addressSearch?.target?.value?.trim();
    // this.getSuggestions(searchStr);
    if (searchStr?.length > 4) {
      if (this.thirdPartyLookupTimeoutFn)
        clearTimeout(this.thirdPartyLookupTimeoutFn);

      let params: any = { search_3rd_party: 1 };
      if (
        searchStr?.length > 12 ||
        (googleSearchPrefixes?.some((prefix) =>
          searchStr?.toLowerCase()?.startsWith(prefix),
        ) &&
          searchStr?.length > 6)
      )
        params.address_method = 'google_search';

      if ([5, 10, 15, 20, 25, 30, 35].includes(searchStr?.length)) {
        this.gtAddressDbLookup(searchStr, params);
      } else {
        this.thirdPartyLookupTimeoutFn = setTimeout(() => {
          this.gtAddressDbLookup(searchStr, params);
        }, 1000);
      }
    } else if (
      searchStr?.length > 2 &&
      this.instanceRegion?.toLowerCase() === 'australia'
    ) {
      this.gtAddressDbLookup(searchStr);
    }
  }

  async useCurrentLocation() {
    this.spinnerService.show();
    this.reverseLookupGps = await this.deviceInfoService.getGpsCoordinates();
    this.getAddressFromGps(this.reverseLookupGps);
  }
  getAddressFromGps(gps: any) {
    this.spinnerService.show();
    this.appService
      .getReverseLocation(gps?.lat, gps?.lon)
      .subscribe((response: any) => {
        let addressStreet = response?.address?.Address.split(' ');
        let streetName = [
          ...addressStreet?.filter(
            (item: any) => item != response?.address?.AddNum,
          ),
        ].join(' ');
        const address: any = this.dictStringConvert({
          address1: response?.address?.AddNum || '',
          address2: streetName,
          address3: null,
          city_name: response?.address?.Neighborhood
            ? response?.address?.Neighborhood
            : response?.address?.City,
          state_code:
            response?.address?.RegionAbbr || response?.address?.Region,
          longitude: gps?.lon,
          latitude: gps?.lat,
          postcode: response?.address?.Postal,
          state_name:
            response?.address?.Region || response?.address?.RegionAbbr,
          country_name: response?.address?.CntryName,
        });

        this.addressSelected(address);

        this.spinnerService.hide();
      });
  }
  onStateInput() {
    // in case user selected an address which contains no state and state code. need to fill statue code because of validation
    if (!this.addressForm?.value?.state_code) {
      this.addressForm.controls['state_code'].setValue(
        this.addressForm.value.state_name,
      );
    }
  }
  dictStringConvert(addressDict: any) {
    const data = Object.fromEntries(
      Object.entries(addressDict)?.map(([key, value]) => [
        key,
        typeof value === 'string' ? value?.toUpperCase() : value,
      ]),
    );
    return data;
  }
  emitData(event: any) {
    this.addressForm.controls['latitude'].setValue(event.lat);
    this.addressForm.controls['longitude'].setValue(event.lng);
    this.updateAddress.emit(this.addressForm.value);
  }
}
